export default "__VITE_PUBLIC_ASSET__776c747c__"